import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { ExtranetInvitationOutput, InvitationsListInput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { unwrapItems, type ListPayload } from '../listShape';
import { extranetQueryKeys } from '../queryKeys';

/** `GET /v1/invitation` — les invitations non encore acceptées du compte. */
export const useInvitations = (input: InvitationsListInput) =>
  useQuery({
    queryKey: extranetQueryKeys.invitations.list(input),
    queryFn: async () => {
      const payload = await getExtranetApi().get<InvitationsListInput, ListPayload<ExtranetInvitationOutput>>(
        '/v1/invitation',
        input,
      );
      return unwrapItems(payload);
    },
    placeholderData: keepPreviousData,
  });
